import { useCallback, useEffect, useState } from "react";
import { getCuentaCorriente } from "../service/cuentaCorrienteService";

export function useCuentaCorriente(cliente, filtros) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!cliente) return;

    setLoading(true);
    setError(null);

    try {
      const res = await getCuentaCorriente(cliente, filtros);
      setData(res);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [cliente, filtros]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const refresh = useCallback(() => {
    // console.log("cliente recibido:", cliente);
    fetchData();
  }, [fetchData]);

  return {
    data,
    loading,
    error,
    refresh,
  };
}
